import { Input } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem } from "@mui/material";
import { useAuth } from "../../../auth";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getToken } from "../APIS/clientAPIS";
import Cookies from "js-cookie";

//JWT
import jwtDecode from "jwt-decode";
import { handleBrokenImage } from "../../../lib/utils";
import { getUserInfo } from "../../core/_request";
import { useGlobalStore } from "../../../store/useGlobalStore";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, userType, login, logout, setCurrentUser } = useAuth();
  const { isAuthenticated, user, userLogin, userLogout } = useGlobalStore();
  const [bearerToken, setBearerToken] = useState(
    sessionStorage.getItem("token")
  );
  const [instituteID, setInstituteID] = useState(
    sessionStorage.getItem("InstituteID")
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const cookie_token = Cookies.get("authToken")
  const cookie_role = Cookies.get("authUserRole")

  useEffect(() => {
    if (bearerToken == undefined || bearerToken == null || bearerToken == "") {
      let isMounted = true; // Flag to check if the component is still mounted

      getToken(currentUser?.Emailid).then((res) => {
        setBearerToken(res.accessToken);
        setInstituteID(res.instituteID);
      });
    }
  }, [bearerToken]);

  useEffect(() => {
    const auth = getAuth();
    signInAnonymously(auth)
      .then(() => {
        console.log("SIGNED IN");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ...
      });
    validateTokenFunction();
  }, []);

  const validateTokenFunction = async () => {
    try {
      const jwtToken = Cookies.get("authDataJwt");
      const authUserRole = Cookies.get("authUserRole");

      if (!jwtToken || !currentUser) {


        const decodedToken = jwtDecode(jwtToken);

        const userId = decodedToken?.user_id;

        if (userId) {
          const userInfoResponse = await getUserInfo(userId);
          //  console.log("userInfoResponse ==========>", userInfoResponse)
          if (userInfoResponse?.code === 200) {
            const { data } = userInfoResponse;

            const transformedData = {
              id: data?.user_id || "",
              UserId: data?.user_id || "",
              user_id: data?.user_id || "",
              MobileNo: data?.phone || decodedToken?.phone || "",
              Name: data?.name || decodedToken?.name || "",
              name: data?.name || decodedToken?.name || "",
              country: data?.country || "",
              Country: data?.country || "",
              imageUrl: data?.profile_picture || "",
              ProfileImage: data?.profile_picture || "",
              phone: data?.phone || decodedToken?.phone || "",
              timezone: data?.time_zone || "",
              clerk_id: data?.clerk_id || "",
              email: data?.email || "",
              Emailid: data?.email || "",
              UserType: cookie_role.toLowerCase().includes("expert") ? 3 : 2,
            };

            login(transformedData);
            setCurrentUser(transformedData);
            userLogin(transformedData);
            localStorage.setItem("profile", JSON.stringify(transformedData));

          }
        }
      }
    } catch (error) {
      console.error("Error in validateTokenFunction:", error);
    }
  }
  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate("/expert/settings");
    handleDropdownClose();
  };

  const handleLogoutClick = () => {
    logout();
    handleDropdownClose();
    Cookies.remove("authUserRole", {
      domain: ".unitedwecare.com",
      path: "/",
      // secure: true,
      HttpsOnly: true,
    });
    Cookies.remove("authToken", {
      domain: ".unitedwecare.com",
      path: "/",
      // secure: true,
      HttpsOnly: true,
    });
    Cookies.remove("authDataJwt", {
      domain: ".unitedwecare.com",
      path: "/",
      // secure: true,
      HttpsOnly: true,
    });
    window.location.href = "https://www.unitedwecare.com/";
  };

  const profileImage = currentUser?.ProfileImage?.replace(
    "https://app.uwc.worldhttps://",
    "https://"
  );

  // console.log("currentUser ==========>", currentUser)

  return (
    <div style={{ background: "rgb(115, 88, 155)" }}>
      <Navbar key={"sm"} expand={"sm"} style={{ height: "75px" }}>
        <Container fluid className="justify-content-between px-5">
          <div className="d-flex align-items-center gap-5">
            <Navbar.Brand className="d-none d-md-block">
              <a
                href="https://www.unitedwecare.com/"
                target="_blank"
                className="text-decoration-none"
              >
                <img
                  src="/assets/img/kareify/UWC logo.png"
                  alt=""
                  height={50}
                  style={{ filter: "brightness(50)" }}
                />
              </a>
            </Navbar.Brand>
            <Navbar.Brand className="d-block d-md-none">
              <Link to="/" className="text-decoration-none">
                <img
                  src="/assets/img/kareify/UWC logo.png"
                  alt=""
                  height={20}
                  style={{ filter: "brightness(50)" }}
                />
              </Link>
            </Navbar.Brand>
          </div>
          <Nav className="gap-4 align-items-baseline align-items-md-center justify-content-end">
            <Link to="/expert/appointments">
              <img src="/assets/img/calendar_white_icon.png" alt="" />
            </Link>
            <Link to="/expert/chat">
              <img src="/assets/img/message_white_icon.png" alt="" />
            </Link>
            <Link to="/expert/notifications">
              <img src="/assets/img/bell_white_icon.png" alt="" />
            </Link>
            <div>
              <Button onClick={handleDropdownOpen}>
                <img
                  src={currentUser?.ProfileImage}
                  onError={(e) => {
                    const newLink = handleBrokenImage(
                      currentUser?.ProfileImage
                    );
                    e.target.src = newLink;
                  }}
                  width={45}
                  height={45}
                  alt=""
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    objectPosition: "top",
                  }}
                />
              </Button>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleDropdownClose}
              >
                <MenuItem onClick={handleProfileClick} sx={{ width: "200px" }}>
                  Profile
                </MenuItem>

                <MenuItem onClick={handleLogoutClick} sx={{ width: "200px" }}>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
